var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Paper Plus"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper Plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8342 8.00004H12.4245C9.48226 7.98827 7.07044 10.4257 7.00113 13.4854V29.4441C6.95162 32.4596 9.26159 34.947 12.1629 35C12.2491 35 12.3368 35 12.4245 34.9971H23.724C26.6508 34.9662 29.0046 32.4876 29.0003 29.4441V15.7639L21.8342 8.00004Z",
    fill: "#FC5C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5609 4.60308H13.4743C10.0076 4.58974 7.16594 7.35141 7.08427 10.8181V28.8997C7.02594 32.3164 9.74761 35.1347 13.1659 35.1947C13.2676 35.1947 13.3709 35.1947 13.4743 35.1914H26.7876C30.2359 35.1564 33.0093 32.3481 33.0043 28.8997V13.3997L24.5609 4.60308Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M24.124 4.5835V9.43183C24.124 11.7985 26.039 13.7168 28.4057 13.7235H32.9957",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    d: "M23.8227 21.5238H15.656",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    d: "M19.7409 25.6066V17.4399",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlus);
export default __webpack_public_path__ + "static/media/Paper-Plus.b1b7ad1c.svg";
export { ForwardRef as ReactComponent };